module.exports = __webpack_public_path__ + "static/media/delivery-truck.6bd535e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delivery-truck.svg
// module id = 981
// module chunks = 7